import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./course/course-routing.module').then(m => m.CourseRoutingModule),
  },
];
